export default "__VITE_ASSET__DEZBmJ2s__"